import { simpleReducer } from '@mgc/map-client-shared/lib/ReduxTools';
import { combineReducers } from 'redux';

export default combineReducers({
    visibleTab: simpleReducer('faq', {
        HELP_SHOW_FAQ: 'faq',
        HELP_SHOW_CONTACT: 'contact',
        HELP_SHOW_TOUR: 'tour',
        HELP_SHOW_ABOUT: 'about',
    }),

    faqs: simpleReducer([], {
        RECEIVED_FAQS: (a) => a.payload.response,
    }),

    faqsTransferring: simpleReducer(false, {
        REQUESTING_FAQS: true,
        RECEIVED_FAQS: false,
    }),

    contacts: simpleReducer([], {
        RECEIVED_CONTACTS: (a) => a.payload.response,
    }),

    contactsTransferring: simpleReducer(false, {
        REQUESTING_CONTACTS: true,
        RECEIVED_CONTACTS: false,
    }),

    contactSubjectIndex: simpleReducer(0, {
        UPDATE_CONTACT_SUBJECT_INDEX: (a) => a.payload.index,
        CONTACT_MESSAGE_SENT: 0,
    }),

    contactMessage: simpleReducer('', {
        UPDATE_CONTACT_MESSAGE: (a) => a.payload.message,
        CONTACT_MESSAGE_SENT: '',
    }),

    contactMessageTransferring: simpleReducer(false, {
        SENDING_CONTACT_MESSAGE: true,
        CONTACT_MESSAGE_SENT: false,
    }),

    contactMessageSent: simpleReducer(false, {
        SENDING_CONTACT_MESSAGE: false,
        CONTACT_MESSAGE_SENT: true,
        HELP_SHOW_FAQ: false,
        HELP_SHOW_TOUR: false,
        HELP_SHOW_ABOUT: false,
    }),
});



// WEBPACK FOOTER //
// ./app/reducers/help.js